import React, { useEffect, useState } from 'react';
import { Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import classes from './BasicDropdownOption.module.scss';
import { CheckedIcon } from '../../../../Icons';
import colors from '../../../../../../scss/colors';
import { useWindowSize } from '../../../../../../utils/hooks';
import { responsiveSizeJobs } from '../../../../../../utils/constants';

function CheckboxComponent({ sx, selected, handleOnCheck, uncheckedIcon, checkedIcon, fillColor }) {
  return (
    <Checkbox
      icon={uncheckedIcon}
      checkedIcon={checkedIcon}
      sx={{
        ...sx,
        padding: 0,
        '& .MuiSvgIcon-root': {
          fill: fillColor
        }
      }}
      checked={!!selected}
      onChange={handleOnCheck}
    />
  );
}

export default function BasicDropdownOption({
  text,
  selected = false,
  isLeft = true,
  clickHandler,
  icon = false,
  multiSelect = false,
  sx
}) {
  const [isMounted, setIsMounted] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    // Prevent layout shift by rendering null or a fallback (e.g., a skeleton)
    return null;
  }

  const handleOnCheck = () => {
    clickHandler(!selected);
  };

  const handleContainerClasses = () => {
    if (multiSelect && width > responsiveSizeJobs) {
      return classes.multiSelectContainer;
    }

    if (width < responsiveSizeJobs && multiSelect) {
      if (selected) {
        return `${classes.selectedContainer} ${classes.multiSelectMobileContainer}`;
      }
      return classes.multiSelectMobileContainer;
    }

    return classes.container;
  };

  return (
    <div
      tabIndex={0}
      role="button"
      aria-pressed={selected}
      className={`hover:!bg-navy-light transform transition duration-300 hover:opacity-75 ${handleContainerClasses()} ${isLeft ? '' : classes.right}`}
      onClick={() => clickHandler(!selected)}
    >
      {multiSelect && width > responsiveSizeJobs ? (
        <CheckboxComponent
          checkedIcon={<CheckedIcon isChecked />}
          uncheckedIcon={<CheckedIcon />}
          sx={sx}
          selected={selected}
          handleOnCheck={handleOnCheck}
          fillColor={selected ? colors.WHITE : colors.PAGE_BACKGROUND}
        />
      ) : (
        <div className={`${classes.marker} ${selected ? classes.selected : ''}`} />
      )}
      <p
        role="presentation"
        onClick={() => multiSelect && handleOnCheck()}
        className={`${selected && classes.selectedText} ${classes.text}`}
      >
        {text}
      </p>
      {icon && <div style={{ width: '16px', height: '16px' }}>{icon}</div>}
      {multiSelect && width < responsiveSizeJobs && (
        <CheckboxComponent
          uncheckedIcon={<AddIcon />}
          checkedIcon={<CheckIcon />}
          sx={sx}
          selected={selected}
          handleOnCheck={handleOnCheck}
          fillColor={selected ? colors.WHITE : colors.MEDIUM_GREY_V2}
        />
      )}
    </div>
  );
}